import { LiveStatus } from '@/components/marketing/live-status'
import { MONITOR_LOCATIONS } from '@/lib/check-locations'

const proofFacts = [
  { value: '30s', label: 'check interval on every plan' },
  { value: MONITOR_LOCATIONS.stat.value, label: MONITOR_LOCATIONS.stat.label },
  { value: '2–5', label: 'consecutive failures to confirm' },
  { value: '$3/mo', label: 'Pro, 50 monitors' },
]

export function ProofStrip() {
  return (
    <section className="border-y border-border bg-band">
      <div className="container mx-auto px-4 py-8">
      <dl className="grid grid-cols-2 gap-y-6 md:grid-cols-4">
        {proofFacts.map((f) => (
          <div key={f.label} className="px-5 text-center md:border-l md:border-border md:first:border-l-0">
            <dt className="num text-[1.75rem] font-semibold tracking-tight text-foreground">{f.value}</dt>
            <dd className="mt-1 text-sm text-muted-foreground">{f.label}</dd>
          </div>
        ))}
      </dl>
      <div className="mt-6">
        <LiveStatus />
      </div>
      </div>
    </section>
  )
}
